
































































































































































































































































































































import Component, { mixins } from "vue-class-component";
import { IDashboardData } from "@/types/Dashboard.model";
import { MyOptions } from "@/charts/graphData";
import MobileMixin from "@/mixins/mobileMixin";
import DashboardMobileCarousel from "@/components/dashboard/DashboardMobileCarousel.vue";
import TauxCat from "@/homeGraph/tauxCat.vue";
import { Prop, Watch } from "vue-property-decorator";
import Doughnut from "@/charts/Doughnut.vue";
import TotalBarGraph from "@/homeGraph/totalBarGraph.vue";

@Component({
  components: {
    TotalBarGraph, Doughnut,
    DashboardMobileCarousel,
    TauxCat,
  },
})
export default class HomeDashboardMobile extends mixins(MobileMixin) {
  @Prop() public dashboardData!: IDashboardData;
  @Prop() public myOptions!: MyOptions;
  @Prop() public isTTC!: boolean;

  public touch: boolean = false;
  public move: any = [];
  public moved: boolean = false;
  public lastEmittedServices: string[] = [];

  public mounted() {
    // Setup touch events for carousel navigation
    document.addEventListener("touchmove", this.handleTouchMove);
    window.addEventListener("touchend", this.handleTouchEnd);

    // Émettre les services disponibles au montage
    this.emitServices();
  }

  @Watch("dashboardData", { immediate: false, deep: false })
  public onDashboardDataChanged(newData: IDashboardData, oldData: IDashboardData) {
    // Seulement surveiller les changements de services, pas tout l'objet dashboardData
    if (newData && newData.services && this.shouldEmitServices(newData.services)) {
      this.emitServices();
    }
  }

  public beforeDestroy() {
    // Cleanup touch events
    document.removeEventListener("touchmove", this.handleTouchMove);
    window.removeEventListener("touchend", this.handleTouchEnd);
  }

  public handleTouchMove(e: TouchEvent) {
    this.touch = true;
    if (!this.moved) {
      this.logic(e);
    }
  }

  public handleTouchEnd(e: TouchEvent) {
    this.moved = false;
    this.move = [];
  }

  public logic(e: TouchEvent) {
    const currentMove = this.touch ? e.touches[0].clientX : e.touches[0].clientX;
    if (this.move.length === 0) {
      this.move.push(currentMove);
    }
    const carousel = document.getElementById("myCarousel");
    const carousel2 = document.getElementById("myCarousel2");
    const touchX = e.touches[0].clientX;
    const touchY = e.touches[0].clientY;

    if (this.move[this.move.length - 1] - currentMove < -100) {
      this.handleCarouselNavigation(carousel, carousel2, touchX, touchY, "prev");
      this.touch = false;
    } else if (this.move[this.move.length - 1] - currentMove > 100) {
      this.handleCarouselNavigation(carousel, carousel2, touchX, touchY, "next");
      this.touch = false;
    }
  }

  public renderIsReady() {
    this.dashboardData.nbFinished++;
    this.$emit("renderFinished");
  }

  public init() {
    this.$emit("init");
  }

  private shouldEmitServices(currentServices: string[]): boolean {
    // Ne pas émettre si les services n'ont pas changé
    if (!currentServices || currentServices.length === 0) {
      return false;
    }

    // Comparer avec les derniers services émis
    if (this.lastEmittedServices.length === currentServices.length &&
        this.lastEmittedServices.every((service, index) => service === currentServices[index])) {
      return false;
    }

    return true;
  }

  private emitServices() {
    if (this.dashboardData && this.dashboardData.services && this.dashboardData.services.length > 0) {
      // Créer une copie pour éviter les références circulaires
      const servicesToEmit = [...this.dashboardData.services];
      console.log("HomeDashboardMobile - Emitting services:", servicesToEmit);
      this.lastEmittedServices = [...servicesToEmit];
      this.$emit("services", servicesToEmit);
    }
  }

  private handleCarouselNavigation(
    carousel: HTMLElement | null,
    carousel2: HTMLElement | null,
    touchX: number,
    touchY: number,
    direction: "prev" | "next"
  ) {
    if (carousel !== null) {
      const rect = carousel.getBoundingClientRect();
      const selector = `.v-window__${direction}`;
      const navElement = carousel.querySelector(selector);

      if (
        navElement !== null &&
        rect.left <= touchX &&
        touchX <= rect.right &&
        rect.top <= touchY &&
        touchY <= rect.bottom
      ) {
        const btn: HTMLElement = navElement.querySelector(".v-btn") as HTMLElement;
        if (btn !== null) {
          this.moved = true;
          btn.click();
        }
      } else if (carousel2 !== null) {
        const rect2 = carousel2.getBoundingClientRect();
        const navElement2 = carousel2.querySelector(selector);

        if (
          navElement2 !== null &&
          rect2.left <= touchX &&
          touchX <= rect2.right &&
          rect2.top <= touchY &&
          touchY <= rect2.bottom
        ) {
          const btn: HTMLElement = navElement2.querySelector(".v-btn") as HTMLElement;
          if (btn !== null) {
            this.moved = true;
            btn.click();
          }
        }
      }
    }
  }

  get reRenderKey(): string {
    const reRender = (this.dashboardData && this.dashboardData.reRender) ? this.dashboardData.reRender.toString() : "default";
    return `${reRender}`;
  }

  get chartLabels(): string[] {
    return (this.dashboardData && this.dashboardData.donutLabels) ? this.dashboardData.donutLabels : [];
  }

  get chartColors(): string[] {
    return (this.dashboardData && this.dashboardData.colors) ? this.dashboardData.colors : [
      "#26A69A", "#1976D2", "#EF5350", "#FFD54F", "#7E57C2",
      "#03C9A9", "#C0392B", "#2574A9", "#6C7A89", "#1EBC61",
      "#BD02B0", "#0057A0", "#1EBC61", "#870000"
    ];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get getGlobal(): boolean {
    return this.$store.getters["getGlobal"];
  }
}
